var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1763092067521,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 10949,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M786.285714 73.142857q68.022857 0 116.297143 48.274286t48.274286 116.297143l0 548.571429q0 68.022857-48.274286 116.297143t-116.297143 48.274286l-107.446857 0 0-339.968 113.737143 0 17.115429-132.534857-130.852571 0 0-84.553143q0-32.036571 13.458286-47.981714t52.297143-16.018286l69.705143-0.585143 0-118.272q-35.986286-5.12-101.741714-5.12-77.677714 0-124.269714 45.714286t-46.592 129.170286l0 97.718857-114.322286 0 0 132.534857 114.322286 0 0 339.968-303.981714 0q-68.022857 0-116.297143-48.274286t-48.274286-116.297143l0-548.571429q0-68.022857 48.274286-116.297143t116.297143-48.274286l548.571429 0z",
    fill: "#003366",
    "p-id": 10950
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSquare);
export default __webpack_public_path__ + "static/media/facebook-square.ab7595b0e9914d957b754e6b777232f5.svg";
export { ForwardRef as ReactComponent };